import React from 'react';

import type { BatteryLevel } from '../../entities/battery-level';
import type { AllIdFilters } from '../../entities/filters';

import { LevelTag } from './level-tag';

export type DisabledHintProps = {
  currentLabel: string;
  parentLevel?: BatteryLevel;
  parentLabel?: string;
  filters?: AllIdFilters;
};

/**
 * Component that explains why a level filter is disabled and how to enable it.
 * Provides contextual hints based on parent selection state.
 */
export const DisabledHint: React.FC<DisabledHintProps> = ({
  currentLabel,
  parentLevel,
  parentLabel,
  filters,
}) => {
  if (!parentLevel || !parentLabel) {
    return (
      <>
        <LevelTag>{currentLabel}</LevelTag> filter is currently disabled.
      </>
    );
  }

  const parentFilterKey = `${parentLevel}Id` as const;
  const parentValue = filters?.[parentFilterKey];
  const parentSelectionCount = Array.isArray(parentValue)
    ? parentValue.length
    : parentValue
      ? 1
      : 0;

  if (parentSelectionCount === 0) {
    return (
      <>
        Select a <LevelTag>{parentLabel.toLowerCase()}</LevelTag> first to
        enable <LevelTag>{currentLabel.toLowerCase()}</LevelTag> filtering.
      </>
    );
  }

  if (parentSelectionCount > 1) {
    return (
      <>
        Select only 1 <LevelTag>{parentLabel.toLowerCase()}</LevelTag> to enable{' '}
        <LevelTag>{currentLabel.toLowerCase()}</LevelTag> filtering. Currently{' '}
        <LevelTag>{parentSelectionCount}</LevelTag> {parentLabel.toLowerCase()}s
        are selected.
      </>
    );
  }

  return (
    <>
      <LevelTag>{currentLabel}</LevelTag> filter is currently disabled.
    </>
  );
};
